import { type RowData, type TableFeature } from "@tanstack/react-table";

interface OpenFlyoutTableOptions<T> {
  onOpenFlyout?: (row: T) => void;
}

interface OpenFlyoutRowOptions<T> {
  openFlyout: (row: T) => void;
}

declare module "@tanstack/react-table" {
  /* eslint-disable-next-line @typescript-eslint/no-empty-interface */
  interface TableOptionsResolved<TData extends RowData>
    extends OpenFlyoutTableOptions<TData> {}
  /* eslint-disable-next-line @typescript-eslint/no-empty-interface */
  interface Row<TData extends RowData> extends OpenFlyoutRowOptions<TData> {}
}

export const OpenFlyoutFeature: TableFeature = {
  createRow: (row, table): void => {
    row.openFlyout = (value) => {
      table.options.onOpenFlyout?.(value);
    };
  },
};
